var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"x-small":_vm.xSmall,"small":_vm.small,"color":_vm.color,"icon":"","title":_vm.$t('copy_link') || 'Copy link'},on:{"click":_vm.copyCurrentLink}},[_c('v-icon',{attrs:{"small":_vm.small,"color":_vm.color}},[_vm._v("mdi-link-variant")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }